import React from 'react'
import PrivacyBreadcrumb from './PrivacyBreadCrumb';
import PrivacyPolicy from './PrivacyPolicy';

function PrivacyPolicyPage() {
    return ( 
        <>
        <PrivacyBreadcrumb />
        <PrivacyPolicy />
        </>
     );
}

export default PrivacyPolicyPage;